import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import Modal from '../../components/ui/Modal';
import Button from '../../components/ui/Button';

function SessionExpirationModal() {
  const { isSessionExpired, clearSessionExpired } = useAuthStore();
  const navigate = useNavigate();

  const handleRedirect = () => {
    clearSessionExpired();
    navigate('/login', { replace: true });
  };

  // Auto redirect after 3 seconds
  useEffect(() => {
    if (isSessionExpired) {
      const timer = setTimeout(handleRedirect, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSessionExpired]);

  return (
    <Modal isOpen={isSessionExpired} onClose={handleRedirect} title="Sessão Expirada" size="sm">
      <div className="text-center">
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Sua sessão expirou. Você será redirecionado para a página de login em alguns segundos...
        </p>
        <Button onClick={handleRedirect} fullWidth>
          Ir para Login
        </Button>
      </div>
    </Modal>
  );
}

export default SessionExpirationModal;
